function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getCookie } from "services/cookies-service";
import { CONTACT_SALES_FORM_DATA } from "constants/cookies";
import { trackEvent } from "services/bigbrain-service";
import { ADA_CHATBOT_TRIGGERED, ADA_META_DATA_ERROR } from "constants/bigbrain-event-types";
import { ChatSourceName } from "@mondaydotcomorg/chat-client";
import { HUBSPOT_CONTACT_SALES_CTA } from "client/services/hubspot-service/hubspot-constants";
import { ADA_CHATBOT_CONTAINER } from "segments/desktop/iframe/layouts/ada-chatbot-iframe/consts";
const CHATBOT_SCRIPT_URL = "https://microfrontends.monday.com/scripts/growth-cx-mf-renderer.js";
const CHAT_LOCALE_METADATA_KEY = "contactSalesLocale";
const CHAT_CTA_METADATA_KEY = "contactSalesCTA";
const parentElement = ADA_CHATBOT_CONTAINER;
export const enableBotOnPage = (localeId)=>{
    addBotConfig(localeId);
    addBotScript();
    trackEvent(ADA_CHATBOT_TRIGGERED);
};
const addBotConfig = (localeId)=>{
    const contactSalesCTA = localStorage.getItem(HUBSPOT_CONTACT_SALES_CTA);
    let metaData = {
        [CHAT_CTA_METADATA_KEY]: contactSalesCTA,
        [CHAT_LOCALE_METADATA_KEY]: localeId
    };
    try {
        const cookieValue = getCookie(CONTACT_SALES_FORM_DATA);
        if (cookieValue) {
            const decoded = cookieValue.startsWith("%") ? decodeURIComponent(cookieValue) : cookieValue;
            metaData = _object_spread({}, metaData, JSON.parse(decoded));
        }
    } catch (error) {
        trackEvent(ADA_META_DATA_ERROR, {
            kind: error
        });
    }
    window.chatConfig = {
        hideCTA: true,
        parentElement,
        language: localeId,
        triggerName: ChatSourceName === null || ChatSourceName === void 0 ? void 0 : ChatSourceName.CONTACT_SALES_HOMEPAGE,
        context: metaData
    };
};
const addBotScript = ()=>{
    if (document.querySelector(`script[src="${CHATBOT_SCRIPT_URL}"]`)) return;
    const scriptElement = document.createElement("script");
    scriptElement.src = CHATBOT_SCRIPT_URL;
    scriptElement.defer = true;
    document.body.appendChild(scriptElement);
};
